import { render, staticRenderFns } from "./PititimPriceView.vue?vue&type=template&id=5220f0f2&scoped=true"
import script from "./PititimPriceView.vue?vue&type=script&lang=js"
export * from "./PititimPriceView.vue?vue&type=script&lang=js"
import style0 from "./PititimPriceView.vue?vue&type=style&index=0&id=5220f0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220f0f2",
  null
  
)

export default component.exports